import api from './api'

export default {
  getAll (request = {}) {
    return api.get('/produtos', request)
          .then((response) => Promise.resolve(response))
          .catch((error) => Promise.reject(error))
  }
}
